var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7286 11.9194C20.73 11.733 20.6924 11.5484 20.6184 11.3773C20.5444 11.2063 20.4356 11.0524 20.2989 10.9257L12.0001 3.27142L3.70123 10.9257C3.56456 11.0524 3.45577 11.2063 3.38179 11.3773C3.30781 11.5484 3.27025 11.733 3.27152 11.9194V19.3857C3.27152 19.7418 3.41299 20.0835 3.66483 20.3352C3.91666 20.587 4.25823 20.7286 4.61437 20.7286H19.3858C19.7419 20.7286 20.0835 20.587 20.3353 20.3352C20.5872 20.0835 20.7286 19.7418 20.7286 19.3857V11.9194Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20.5V15.3572C15 15 14.5713 15 14.5713 15H9.42869C9 15 9 15.3572 9 15.3572V20.5",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardNew);
export default __webpack_public_path__ + "static/media/DashboardNew.9733ac974e26863356ce7d99ac51be7d.svg";
export { ForwardRef as ReactComponent };